<section class="sorteo-egresados-anahuac">
    <div class="container">
        <div class="row">


            <div class="col-lg-6 my-auto text-center">
                <h1>

                    <span class="paragraph d-block">
                        lista de GANADORES
                    </span>
                    del Sorteo
                    Egresados anáhuac
                </h1>
            </div>

            <div class="col-lg-6 my-auto text-center d-lg-block d-none">
                <img src="/assets/images/soteo-oportuno/lista-ganadores-egr.png" class="img-fluid "
                    alt="Participantes Sorteo Egresados Anáhuac" width="320">
            </div>


        </div>
    </div>
</section>

<section class="stc-winners-opt">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 style="background-color: #ff5900 !important;">
                    LISTA DE GANADORES del SORTEO
                    <span class="d-block">
                        egresados anáhuac 2025
                    </span>
                </h2>
            </div>
            <div class="col-md-12 ">
                <div class=" text-center" style="overflow-x: auto;">

                    <table class="table table-striped">
                        <thead class="text-center">

                            <tr class="text-center cols">
                                <th scope="col" style=" white-space: nowrap; padding: 4px 8px;">Nº Premio
                                </th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Valor</th>
                                <th scope="col">Folio de participación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center first">
                                <td style="width: 60px; white-space: nowrap; padding: 4px 8px;">1</td>
                                <td>María C. G.</td>
                                <td>$100,000.00</td>
                                <td>002775</td>
                            </tr>
                            <tr class="text-center second">
                                <td style="width: 60px; white-space: nowrap; padding: 4px 8px;">2</td>
                                <td>Sofía E. B.</td>
                                <td>$50,000.00</td>
                                <td>003368</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

            <div class="col-12 footer-egr">
                <p class="font-bold">
                   SORTEO DE EGRESADOS ANÁHUAC 2025
                </p>
      

              <p>
                El Sorteo Anáhuac celebró el día viernes 17 de octubre de 2025, a las 10:30 horas, el SORTEO DE EGRESADOS ANÁHUAC 2025 en la Universidad Anáhuac México Campus Sur con domicilio en la Avenida de los Tanques no. 865, Colonia Torres de Potrero, C.P. 01840, Alcaldía Álvaro Obregón, Ciudad de México. Con la presencia de la C. María de Jesús Jiménez Alva, Inspector de la Secretaría de Gobernación, para dar fe de la legalidad del evento.
              </p>

              <p>
                De acuerdo con lo establecido en el Permiso No. <strong class="font-bold">20250121PS06 </strong> otorgado por la Secretaría de Gobernación a Sorteo Anáhuac, A.C., los resultados de los ganadores, que se han hecho acreedores a un premio, han de ser publicados de forma posterior al evento del sorteo en la página de internet https://www.sorteoanahuac.mx/ y nuestras redes sociales a partir del día 18 de octubre de 2025 y de acuerdo a lo registrado ante SEGOB, solo aparecerá el nombre propio de los ganadores, completándose con las iniciales de cada uno de los apellidos, y adicionalmente, se publicará la lista con los  nombres completos de los ganadores en las Instalaciones de la Universidad Anáhuac México Campus Norte, ubicada en la Av. Universidad no. 46 Colonia Lomas de Anáhuac, CP. 52786, Huixquilucan Estado de México.
              </p>

              <p>
                Los premios serán pagados y entregados de conformidad con lo establecido en las bases de Sorteo, los premios menores a 1,500 (UMA) $169,710.00 (Ciento sesenta y nueve mil setecientos diez pesos 00/100 m.n.) se realizará dentro de los 20 (veinte) días hábiles contados a partir de la celebración del sorteo, en Avenida Universidad Anáhuac N° 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México, piso 7 del edificio de Biblioteca, en horario de lunes a jueves de 10:00 a 18:00 hrs. y los viernes de 10:00 a 14:00 hrs. 
Para más información sobre dónde reclamar la entrega de los premios, documentos necesarios para recibirlos diríjase a: www.sorteoanahuac.mx, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México o al teléfono: 01(55) 5328-8096 ext 2137.

              </p>

              <p>
                Las personas que resulten ganadoras deberán presentar una identificación oficial vigente con fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses) y CURP.
En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez, Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800.

              </p>

            </div>

        </div>
    </div>
</section>